import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumberFormat'
})
export class CustomNumberFormatPipe implements PipeTransform {
  transform(value: number | string, fractionDigits: number = 2, minimumFractionDigits: number | null = null, isDecimal: boolean = false): string {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    if (isNaN(value)) {
      return '';
    }

    // For decimal data type, preserve the exact value without rounding
    if (isDecimal) {
      const parts = value.toString().split('.');
      const wholePart = new Intl.NumberFormat('en-US').format(parseInt(parts[0]));
      
      if (parts.length > 1) {
        // Keep the decimal part as is
        const decimalPart = parts[1].padEnd(fractionDigits, '0').slice(0, fractionDigits);
        return `${wholePart}.${decimalPart}`;
      }
      return wholePart;
    }
    
    if (Number.isInteger(value)) {
      return new Intl.NumberFormat('en-US').format(value);
    }

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : fractionDigits,
      maximumFractionDigits: fractionDigits
    }).format(value);
  }
}
